// extracted by mini-css-extract-plugin
export default {"p":"_1f60622cf3 _58906e15e8 e15a5d9560","clr":"_94e0237b88","dls":"_8da2fa1a48"};